import { useMemo } from 'react';
import MetricCard from '../shared/MetricCard';
import Badge from '../shared/Badge';
import VendorTag from '../shared/VendorTag';
import DataTable from '../shared/DataTable';
import EmptyState from '../shared/EmptyState';
import { formatMoney, formatDate } from '../../utils/formatters';

export default function InvalidROReferences({ data }) {
  const items = data?.items || [];
  const totalCost = data?.total_cost_usd || items.reduce((s, r) => s + (r.total_cost_usd || 0), 0);

  const columns = useMemo(() => [
    {
      key: 'po_number',
      label: 'PO / RO',
      render: (row) => (
        <div>
          <div className="font-bold text-sm">
            PO #{row.po_number} &rarr; RO #{row.referenced_ro_number || row.referencedRoNumber}
            <span className="ml-2 px-1.5 py-0.5 bg-red-50 text-red-800 rounded text-[10px] font-bold">INVALID</span>
          </div>
          <div className="text-xs text-red-600 font-semibold">{row.reason}</div>
        </div>
      ),
    },
    {
      key: 'part_name',
      label: 'Part',
      render: (row) => <span className="text-sm">{row.part_name}</span>,
    },
    {
      key: 'vendor_name',
      label: 'Vendor',
      render: (row) => <VendorTag name={row.vendor_name} />,
    },
    {
      key: 'invoice_number',
      label: 'Invoice',
      render: (row) => <span className="text-xs font-mono">{row.invoice_number}</span>,
    },
    {
      key: 'order_date',
      label: 'Ordered',
      render: (row) => <span className="text-xs">{formatDate(row.order_date)}</span>,
    },
    {
      key: 'total_cost_usd',
      label: 'Cost',
      align: 'right',
      render: (row) => <span className="font-bold">{formatMoney(row.total_cost_usd)}</span>,
    },
  ], []);

  return (
    <div>
      <div className="flex gap-3 mb-6 flex-wrap">
        <MetricCard
          label="Invalid References"
          value={items.length.toString()}
          accent="#C62828"
          icon={'\u274C'}
        />
        <MetricCard
          label="Affected Cost"
          value={formatMoney(totalCost)}
          sub="On mislinked POs"
          accent="#E65100"
          icon={'\uD83D\uDCB0'}
        />
      </div>

      <div className="text-xs text-gray-500 mb-4 px-3 py-2 bg-red-50 rounded-lg border border-red-200">
        Purchase orders referencing repair order numbers that don't exist, have been deleted, or are in an invalid state. These need to be corrected so costs are properly tracked.
      </div>

      {items.length > 0 ? (
        <DataTable columns={columns} data={items} />
      ) : (
        <EmptyState text="No invalid RO references found" />
      )}
    </div>
  );
}
